import * as yup from 'yup';
import {i18n2} from 'features/i18n/i18n';

export const parameterSchema = () =>
  yup.object({
    port: yup
      .number()
      .nullable(true)
      .typeError(i18n2._('Ingrese un número correcto'))
      .label(i18n2._('Puerto')),
    host: yup.string().nullable(true).label(i18n2._('Host')),
    emailFrom: yup.string().nullable(true).label(i18n2._('Email')),
    validateDomain: yup.boolean().label(i18n2._('Validar dominio')),
    domain: yup.string().nullable(true).label(i18n2._('Dominio')),
    validateGroup: yup.boolean().label(i18n2._('Validar grupo')),
    hseGroup: yup.string().nullable(true).label(i18n2._('Grupo de HSE')),
    qaGroup: yup.string().nullable(true).label(i18n2._('Grupo de QA')),
    itpsGroup: yup.string().nullable(true).label(i18n2._('Grupo de ITPS')),
    collaboratorGroup: yup
      .string()
      .nullable(true)
      .label(i18n2._('Grupo de colaboradores')),
    trainerGroup: yup
      .string()
      .nullable(true)
      .label(i18n2._('Grupo de capacitadores')),
    user: yup.string().label(i18n2._('Usuario')),
    password: yup.string().label(i18n2._('Contraseña')),
    serverLDAP: yup.string().label(i18n2._('Server de LDAP')),
    smtpUser: yup.string().nullable(true).label(i18n2._('SMTP Usuario')),
    smtpPassword: yup.string().nullable(true).label(i18n2._('SMTP Contraseña')),
    useSsl: yup.boolean().label(i18n2._('Usar SSL')),
    useStartTls: yup.boolean().label(i18n2._('Usar STARTTLS')),
    anonimo: yup.boolean().label(i18n2._('Modo anónimo')),
    production: yup
      .number()
      .typeError(i18n2._('Ingrese un número correcto'))
      .label(i18n2._('Produccion')),
    filesContentRoute: yup
      .string()
      .nullable(true)
      .label(i18n2._('Ruta de materiales')),
    filesSRegistryRoute: yup
      .string()
      .nullable(true)
      .label(i18n2._('Ruta de registro de firmas')),
    pwdRequireMinLength: yup.boolean(),
    pwdMinLength: yup.number().when('pwdRequireMinLength', {
      is: true,
      then: yup
        .number()
        .min(6, i18n2._('Debe ser mayor o igual a 6'))
        .required(i18n2._('Campo obligatorio')),
      otherwise: yup.number().nullable(),
    }),
    pwdRequireNumber: yup.boolean(),
    pwdRequireSymbol: yup.boolean(),
    pwdDisallowObviousSequences: yup.boolean(),
    pwdDisallowUserData: yup.boolean(),
    enablePasswordHistory: yup.boolean(),
    passwordHistoryCount: yup.number().when('enablePasswordHistory', {
      is: true,
      then: yup
        .number()
        .min(2, i18n2._('Debe ser mayor o igual a 2'))
        .required(i18n2._('Campo obligatorio')),
      otherwise: yup.number().nullable(),
    }),
    tokenExpirationMinutes: yup
      .number()
      .min(1, i18n2._('Debe ser mayor a 0'))
      .label(i18n2._('Expiración de token (minutos)')),
    idleTimeoutMinutes: yup
      .number()
      .min(1, i18n2._('Debe ser mayor a 0'))
      .label(i18n2._('Timeout por inactividad (minutos)')),
    enableFailedLoginLockout: yup.boolean(),
    failedLoginAttemptsLimit: yup.number().when('enableFailedLoginLockout', {
      is: true,
      then: yup
        .number()
        .min(1, i18n2._('Debe ser mayor a 0'))
        .required(i18n2._('Campo obligatorio')),
      otherwise: yup.number().nullable(),
    }),
  });
